<template>
  <div id="activityList">
    <crumbs title="活动数据管理" />
    <el-row class="query-bar">
      <el-col :span="12">
        <el-button
          type="warning"
          icon="el-icon-circle-plus"
          @click="redirectByPath('/activityInfo/addition')"
          >添加</el-button
        >
        <el-button
          type="warning"
          plain
          icon="el-icon-delete"
          @click="handleBatchDelete"
          >删除</el-button
        >
      </el-col>
      <el-col :span="4">
        <activity-type v-model="queryCondition.AcType" />
      </el-col>
      <el-col :span="6">
        <el-input
          v-model="queryCondition.AcTitle"
          clearable
          placeholder="活动标题"
        >
        </el-input>
      </el-col>
      <el-col class="flush-right" :span="2">
        <el-button
          @click="handleSearch"
          size="medium"
          type="success"
          icon="el-icon-search"
          round
          >查询</el-button
        >
      </el-col>
    </el-row>
    <div
      class="query-table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <div>
        <el-table
          :data="queryList"
          @selection-change="handleSelectionChange"
          border
          stripe
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column type="selection" width="40"> </el-table-column>
          <el-table-column prop="AcCode" label="活动编号"></el-table-column>

          <el-table-column
            prop="AcTitle"
            label="活动标题"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="AcTypeName" label="活动类型"></el-table-column>
          <el-table-column prop="CreateTime" label="创建时间"></el-table-column>

          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flush-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.PageSize"
          :current-page.sync="queryCondition.PageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Crumbs from "./component/crumbs";
import ActivityType from "./component/activityType";
export default {
  name: "activityList",
  created() {
    this.loadList();
  },
  data() {
    return {
      total: 0,
      //查询条件
      queryCondition: {
        AcType: "",
        AcTitle: "",
        PageIndex: 1,
        PageSize: 15
      },
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: [],
      //表格当前的选项（多选）
      multipleSelection: []
    };
  },
  methods: {
    //获取列表
    loadList() {
      //初始化
      this.queryList = [];
      this.isLoading = true;
      let obj = {
        AcType:
          this.queryCondition.AcType === "" ? -1 : this.queryCondition.AcType
      };
      this.requestApi(
        "activity",
        "getActivityList",
        { ...this.queryCondition, ...obj },
        res => {
          this.isLoading = false;
          this.total = res.Count;
          this.queryList = res.ActivityList;
        }
      );
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.PageIndex = 1;
      this.loadList();
    },
    //删除
    //点击批量删除
    handleBatchDelete() {
      const idList = this.multipleSelection.map(item => item.Id);
      if (idList.length) {
        this.$confirm("此操作将批量删除所选中的数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.loadDeleteData(idList);
          })
          .catch(() => {
            this.$message.info("已取消删除");
          });
      }
    },
    //点击一条删除
    handleDelete(row) {
      this.$confirm("此操作将删除当前所选中的数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loadDeleteData([row.Id]);
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    loadDeleteData(idList) {
      this.requestApi("activity", "batchDelete", idList, res => {
        this.$message({
          message: res.Message,
          type: res.Code === 0 ? "success" : "error"
        });
        if (res.Code === 0) {
          this.loadList();
        }
      });
    },
    //点击选中/取消选中表格选择项
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    //点击编辑
    handleEdit(row) {
      const { Id } = row;
      this.redirectByPath(`/activityInfo/modification`, { Id });
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    }
  },
  components: {
    Crumbs,
    ActivityType
  }
};
</script>

<style lang="less"></style>
